const state = () => ({
    openDialog: false,
    waiversUser: [],
    bSendWaiver: false,
    roleActive: 'Spectator'
});

const mutations = {
    SET_OPEN_DIALOG(state, value) {
        state.openDialog = value;
    },
    SET_WAIVERS_USER(state, value) {
        state.waiversUser = value;
    },
    SET_B_SEND_WAIVER(state, value) {
        state.bSendWaiver = value;
    },
    SET_ROLE_ACTIVE(state, value) {
        state.roleActive = value
    }
}

const getters = {
    GET_OPEN_DIALOG: (state) => state.openDialog,
    GET_WAIVERS_USER: (state) => state.waiversUser,
    GET_B_SEND_WAIVER: (state) => state.bSendWaiver,
    GET_ROLE_ACTIVE: (state) => state.roleActive
}

const actions = {
    SET_OPEN_WAIVER_DIALOG_ACTION(context,value) {  
        context.commit('SET_OPEN_DIALOG', value)
    },
    SET_WAIVERS_FOR_DIALOG_ACTION(context, value) {
        context.commit('SET_WAIVERS_USER', value)
    },
    SET_B_SEND_WAIVER_FOR_DIALOG_ACTION(context, value) {
        context.commit('SET_B_SEND_WAIVER', value)
    },
    SET_ROLE_ACTIVE_ACTION(context, value) {
        context.commit('SET_ROLE_ACTIVE', value)
    }
}

export default {
    state, mutations, actions, getters
  }